(() => {
	const BIO_MAX_HEIGHT = 200;
	const wraps = document.querySelectorAll('.our-team-bio-wrap');

	if (!wraps.length) {
		return;
	}

	const initWrap = (wrap) => {
		const bio = wrap.querySelector('.our-team-bio');
		const toggle = wrap.querySelector('.our-team-bio-toggle');

		if (!bio || !toggle) {
			return;
		}

		if (bio.scrollHeight < BIO_MAX_HEIGHT) {
			return;
		}

		wrap.classList.add('is-truncatable');
		bio.style.setProperty('--bio-full-height', `${bio.scrollHeight}px`);
		toggle.hidden = false;

		toggle.addEventListener('click', () => {
			const isCurrentlyExpanded = wrap.classList.contains('is-expanded');

			if (!isCurrentlyExpanded) {
				wraps.forEach((otherWrap) => {
					if (otherWrap === wrap || !otherWrap.classList.contains('is-expanded')) {
						return;
					}

					otherWrap.classList.remove('is-expanded');

					const otherToggle = otherWrap.querySelector('.our-team-bio-toggle');
					if (otherToggle) {
						otherToggle.setAttribute('aria-expanded', 'false');
					}
				});
			}

			const isExpanded = wrap.classList.toggle('is-expanded');
			toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
		});
	};

	const init = () => {
		wraps.forEach(initWrap);
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
